import { defineStore } from 'pinia';
import { ref } from 'vue';

/**
 * App Store - Global application state
 *
 * Manages global UI state including snackbar notifications,
 * loading states, and navigation drawer.
 */
export const useAppStore = defineStore('app', () => {
    // Loading state
    const loading = ref(false);

    // Snackbar state
    const snackbar = ref({
        show: false,
        message: '',
        color: 'info',
        timeout: 3000
    });

    // Navigation drawer state (for mobile)
    const drawer = ref(false);

    // Actions
    function setLoading(value) {
        loading.value = value;
    }

    function showSnackbar(message, color = 'info', timeout = 3000) {
        snackbar.value = {
            show: true,
            message,
            color,
            timeout
        };
    }

    function hideSnackbar() {
        snackbar.value.show = false;
    }

    function toggleDrawer() {
        drawer.value = !drawer.value;
    }

    function closeDrawer() {
        drawer.value = false;
    }

    // Convenience methods for common snackbar types
    function showSuccess(message) {
        showSnackbar(message, 'success');
    }

    function showError(message) {
        showSnackbar(message, 'error', 5000);
    }

    function showWarning(message) {
        showSnackbar(message, 'warning', 4000);
    }

    function showInfo(message) {
        showSnackbar(message, 'info');
    }

    return {
        // State
        loading,
        snackbar,
        drawer,

        // Actions
        setLoading,
        showSnackbar,
        hideSnackbar,
        toggleDrawer,
        closeDrawer,

        // Convenience methods
        showSuccess,
        showError,
        showWarning,
        showInfo
    };
});
